import { render } from "./BaseDetailsHeader.vue?vue&type=template&id=7de8b7ec"
import script from "./BaseDetailsHeader.vue?vue&type=script&lang=js"
export * from "./BaseDetailsHeader.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__